import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { Loader2 } from "lucide-react";
import { getDefaultRouteForUser } from "../../../utils/roleAccess";

type ClientRouteGuardProps = {
  children: React.ReactNode;
};

/**
 * Portail client : uniquement rôle CLIENT + jeton portail.
 * Les comptes staff sont renvoyés vers le pilotage admin (pas de déconnexion forcée).
 */
export default function ClientRouteGuard({ children }: ClientRouteGuardProps): React.JSX.Element {
  const { user, isLoading, clientAccessToken } = useAuth();
  const roleStored = localStorage.getItem("role");
  const role = user?.role ?? roleStored;
  const isClient = String(role ?? "").toLowerCase() === "client";
  const hasClientPortalSession = localStorage.getItem("clientPortalSession") === "true";
  const hasClientToken = Boolean(
    clientAccessToken ?? localStorage.getItem("clientAccessToken")
  );

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center gap-2 bg-slate-950 text-slate-400">
        <Loader2 className="h-5 w-5 animate-spin" />
        Chargement…
      </div>
    );
  }

  if (!isClient) {
    return <Navigate to={getDefaultRouteForUser({ role })} replace />;
  }

  if (!(hasClientPortalSession && hasClientToken)) {
    return <Navigate to="/client/login" replace />;
  }

  return <>{children}</>;
}
